(() => {
  const incoming = new URLSearchParams(window.location.search);

  document.querySelectorAll('[data-offer]').forEach((link) => {
    const target = new URL(link.href);

    for (const key of new Set(incoming.keys())) {
      if (key === 'view') continue;
      target.searchParams.delete(key);
      incoming.getAll(key).forEach((value) => target.searchParams.append(key, value));
    }

    link.href = target.href;
  });

  const reasonFour = document.getElementById('reason-4');
  const closeStrip = document.getElementById('close-strip');
  const sticky = document.getElementById('mobile-cta');
  let scheduled = false;

  const updateSticky = () => {
    scheduled = false;
    if (!reasonFour || !sticky) return;

    const reasonFourPassed = reasonFour.getBoundingClientRect().bottom <= 0;
    const closeReached = closeStrip && closeStrip.getBoundingClientRect().top < window.innerHeight * 0.75;
    sticky.hidden = !reasonFourPassed || Boolean(closeReached);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateSticky);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  updateSticky();
})();
